 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"1a9c84bd184b2cad2161d97381475161ad645037","3":"cbb4450d745b399ec56373fc3db0dbf6bbdfc02a","4":"80e486fdc3f60e3375db6fd3b77993ff65bf25c1","5":"e363da9d6d5a1cef57497015254d1fe0221d9e99","8":"component---src-pages-404-js","9":"component---src-pages-company-about-js","10":"component---src-pages-company-about-us-js","11":"component---src-pages-company-career-js","12":"component---src-pages-company-culture-js","13":"component---src-pages-company-partnership-js","14":"component---src-pages-company-testimonials-js","15":"component---src-pages-contact-js","16":"component---src-pages-contact-us-js","17":"component---src-pages-index-js","18":"component---src-pages-make-e-commerce-development-js","19":"component---src-pages-make-shopify-development-js","20":"component---src-pages-make-ui-ux-js","21":"component---src-pages-make-web-application-development-js","22":"component---src-pages-make-website-development-js","23":"component---src-pages-portfolio-all-portfolio-js","24":"component---src-pages-portfolio-js","25":"component---src-pages-privacy-policy-js","26":"component---src-pages-services-angular-development-js","27":"component---src-pages-services-gatsby-development-js","28":"component---src-pages-services-magento-development-js","29":"component---src-pages-services-maintain-js","30":"component---src-pages-services-make-js","31":"component---src-pages-services-market-js","32":"component---src-pages-services-reactjs-development-js","33":"component---src-pages-services-wordpress-development-js","34":"component---src-pages-terms-of-use-js","35":"component---src-templates-author-posts-js","36":"component---src-templates-blog-event-js","37":"component---src-templates-blog-js","38":"component---src-templates-blogpost-js"}[chunkId]||chunkId) + "-" + {"0":"c161189c7f343f7963b7","1":"e9d24b1846c7d6eb9685","2":"f4b02237bb6f34455e56","3":"5dd0d92ecf40e197503c","4":"b1b1737e84c63a4eb4b5","5":"036be63064424f55c95a","8":"f5f73120134cb5e80150","9":"8af7659cbb1ee89f6bfa","10":"b1767838528ab0b225e1","11":"44061e6e1ad91cf7d6f4","12":"4b23dfb60ecbe8c70773","13":"ee5151ea12d1f65ba182","14":"126d7224bfb16bb15cb0","15":"9fecdc8b66be91d0e40b","16":"d470cd56bbb2b9444916","17":"2bc99777df00f5e5c6f8","18":"f6bc31f89735966f773d","19":"adaa1032c30527a05413","20":"e7909cd5c9b838c03935","21":"d126f1ae5e1a0d03ae67","22":"72d3454f0b8a0833a6d1","23":"ec25ea53b1d498b2b816","24":"cc3b48a6b4d29af303b0","25":"b2df4d284823c38ddf69","26":"f17b4422da0d96887665","27":"110dced1677ba6f8b03a","28":"1694a6600dd6898e9303","29":"74cd849b4265d6475a32","30":"027314213c2e59b04a53","31":"44d1de2e59e1b95c54d2","32":"05021bba753d8eee5486","33":"c3b02c6519f6fbbc1033","34":"8a4a1f5b9974d1b9f06d","35":"e79b7c3762a8639c33c4","36":"479d2368e6eec3d80439","37":"463ff79a3b641c8a34cd","38":"7cdbbe2485cee079e40f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"1a9c84bd184b2cad2161d97381475161ad645037","3":"cbb4450d745b399ec56373fc3db0dbf6bbdfc02a","4":"80e486fdc3f60e3375db6fd3b77993ff65bf25c1","5":"e363da9d6d5a1cef57497015254d1fe0221d9e99","8":"component---src-pages-404-js","9":"component---src-pages-company-about-js","10":"component---src-pages-company-about-us-js","11":"component---src-pages-company-career-js","12":"component---src-pages-company-culture-js","13":"component---src-pages-company-partnership-js","14":"component---src-pages-company-testimonials-js","15":"component---src-pages-contact-js","16":"component---src-pages-contact-us-js","17":"component---src-pages-index-js","18":"component---src-pages-make-e-commerce-development-js","19":"component---src-pages-make-shopify-development-js","20":"component---src-pages-make-ui-ux-js","21":"component---src-pages-make-web-application-development-js","22":"component---src-pages-make-website-development-js","23":"component---src-pages-portfolio-all-portfolio-js","24":"component---src-pages-portfolio-js","25":"component---src-pages-privacy-policy-js","26":"component---src-pages-services-angular-development-js","27":"component---src-pages-services-gatsby-development-js","28":"component---src-pages-services-magento-development-js","29":"component---src-pages-services-maintain-js","30":"component---src-pages-services-make-js","31":"component---src-pages-services-market-js","32":"component---src-pages-services-reactjs-development-js","33":"component---src-pages-services-wordpress-development-js","34":"component---src-pages-terms-of-use-js","35":"component---src-templates-author-posts-js","36":"component---src-templates-blog-event-js","37":"component---src-templates-blog-js","38":"component---src-templates-blogpost-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"4276c29e0fe8c7b6dfbc","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
